import { useState } from '#app'

/**
 * This useFCPModel composition function is a helper function for providing the model from the Nuxt 
 * state via useState().
 * 
 * This function provides a couple of ways of using the model
 * 1) Reactive.  This method returns the model as a reactive object where all of the objects can be referenced directly.
 * In other words, a .value call is not required to get the data.  The upside of this is no need to call value on the
 * property.  The downside is that the propery must be referenced in dot notation.  A property cannot be reactive in and
 * of itself via a ref.  Also, the properties in the object cannot be destructured
 * Example  const { myProp } = useFCPModel()
 * 
 * If we try to destructure on a reactive object we will lose reactivity.
 * 
 * 2) An object of refs
 * The downside of refs is primarily the need to reference the .value property of the ref in order to get at the value.
 * 
 * By default, we return an object of refs:
 * 
 * i.e {
 *  prop1: ref(),
 *  prop2: ref()
 * }
 * 
 * By calling useFCPModel(true)  you will receive a reactive object that looks like the following:
 * {
 *   prop1: 'someValue',
 *   prop2: 'someOtherValue'
 * }
 * 
 * An analysis of the difference between ref and reactive can be investigated here:
 * https://vuejsdevelopers.com/2022/06/01/ref-vs-reactive/
 */
export default () => {
    const ref = useState('model')
    const retVal = reactive(ref.value)
    const refs = toRefs(retVal)

    refs.plan = computed(() => {
        if (refs.profile.value && refs.context.value) {
          const { getPlan } = usePlan(refs.profile.value, refs.context.value)
          return getPlan()
        }
        return null
    })

    refs.networkId = computed(() => {
      if (refs.profile.value && refs.context.value) {
        const { getNetworkId } = usePlan(refs.profile.value, refs.context.value)
        return getNetworkId(refs.profile.value, refs.context.value)
      }
      return null
    })

    refs.groupNumber = computed(() => {
      if (refs.profile.value && refs.context.value) {
        const { getGroupNumber } = usePlan(refs.profile.value, refs.context.value)
        return getGroupNumber(refs.profile.value, refs.context.value)
      }
      return null
    })

    return refs
}